import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';

function LoginPage() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isResetMode, setIsResetMode] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('Login attempt:', { email, password });

        try {
            const response = await fetch('/.netlify/functions/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email, password }),
            });

            const data = await response.json();
            console.log('Login response:', data);

            if (response.ok) {
                localStorage.setItem('token', data.token);

                // Check if affiliate needs to accept terms
                if (data.role === 'affiliate' && (!data.terms_accepted_at || data.terms_accepted_at === null)) {
                    console.log('Redirecting to accept terms');
                    navigate('/accept-terms');
                } else {
                    console.log('Redirecting to dashboard');
                    navigate(data.role === 'affiliate' ? '/affiliate' : '/admin');
                }
            } else {
                alert(data.error || 'Login failed');
            }
        } catch (error) {
            console.error('Login error:', error);
            alert('An error occurred during login. Please try again.');
        }
    };

    const handleForgotPassword = async (e) => {
        e.preventDefault();
        if (!email) {
            alert('Please enter your email address');
            return;
        }

        try {
            const response = await fetch('/.netlify/functions/forgot-password', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });

            const data = await response.json();

            if (response.ok) {
                alert('Password reset instructions have been sent to your email');
                setIsResetMode(false);
            } else {
                alert(data.error || 'Failed to process password reset request');
            }
        } catch (error) {
            console.error('Password reset error:', error);
            alert('An error occurred. Please try again.');
        }
    };

    return (
        <div className="login-container">
            <div className="login-header">
                <h2>{isResetMode ? 'Reset Password' : 'Welcome Back'}</h2>
            </div>
            <form onSubmit={isResetMode ? handleForgotPassword : handleSubmit}>
                <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter your email"
                        required
                    />
                </div>
                {!isResetMode && (
                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter your password"
                            required
                        />
                    </div>
                )}
                <button type="submit">
                    {isResetMode ? 'Reset Password' : 'Sign In'}
                </button>
            </form>
            <div className="forgot-password">
                <button
                    className="text-button"
                    onClick={() => setIsResetMode(!isResetMode)}
                >
                    {isResetMode ? 'Back to Login' : 'Forgot/Reset Password?'}
                </button>
            </div>
        </div>
    );
}

export default LoginPage;
